import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent }  from '@angular/common/http';
import { Observable, of, throwError, interval, BehaviorSubject } from 'rxjs';
import { AuthService} from './authService';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor 
{  
 
	constructor(public authService: AuthService,  private router: Router){}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		
		console.log("TokenInterceptor URL=" + request.url );
	
    
	console.log("Token=" + this.authService.getJwtToken());     
    	 
    if (request.url.endsWith("/refreshPasura") &&  this.authService.getRefreshToken()!=undefined )  
	 {
	 	console.log("Set RefreshToken");
	 	request=this.addToken(request, this.authService.getRefreshToken());
	 	        
	 }else if (request.url.startsWith("/api/") &&  this.authService.getJwtToken()!=undefined )  
	 {
	 	console.log("Set Token");
	 	request=this.addToken(request, this.authService.getJwtToken());       
	 }
      
   
    return next.handle(request).pipe(catchError(error => 
    {
    	console.log("Http-Error -> " + JSON.stringify(error));
    	
      if (error instanceof HttpErrorResponse && error.status === 401) 
      {
      
		      if (error.error=='RefreshToken is exp')
		      {
		      	console.log("------->  Logout ");
	  		  	sessionStorage.removeItem("PasuraRefreshToken");
	  		  	
		  	  	this.router.navigate(['/login']);
		  	  	return throwError(error);
	        
	      }
      	return this.handle401Error(request, next);
      	
    	}else if (error instanceof HttpErrorResponse && error.status === 500)
	    	{
	  		  	sessionStorage.removeItem("PasuraRefreshToken");
    	 		this.router.navigate(['/login']);
		  	  	return throwError(error);
       
      } else {
      
        return throwError(error);
      }
    }));

  	}
  
	private isRefreshing = false;
	private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	
	private handle401Error(request: HttpRequest<any>, next: HttpHandler) 
	{
	  
	  console.log("handle401Error");
	  if (!this.isRefreshing) 
	  {
	    console.log("handle401Error A");
	    this.isRefreshing = true;
	    this.refreshTokenSubject.next(null);
	
	    return this.authService.refreshToken().pipe(
	      switchMap((token: any) => {
	        this.isRefreshing = false;
	        this.refreshTokenSubject.next(token.jwt);
	        
	        return next.handle(this.addToken(request, token.jwt));
	      }));
	
	  }else{
	  
	  	 console.log("handle401Error B");
	    return this.refreshTokenSubject.pipe(
	      filter(token => token != null),
	      take(1),
	      switchMap(jwt => {
	        return next.handle(this.addToken(request, jwt));
	      }));
	  }
	}
	
	 private addToken(request: HttpRequest<any>, token: string) 
	 {
		 return request.clone({
	      setHeaders: {
	        "Authorization": "Bearer " +token
	      }
	  });
  }

}
